import React from 'react';

const Tooltip = ({
  active,
  payload
}) => {
  if (active && payload && payload[0]) {
    return /*#__PURE__*/React.createElement("div", {
      className: "chart__tooltip"
    }, /*#__PURE__*/React.createElement("span", null, `${payload[0].payload.label}`), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, `${payload[0].payload.percentage.toFixed(0)}%`)));
  }

  return null;
};

export default Tooltip;